module.exports = __webpack_public_path__ + "img/6_82.96de824b.png";